export default {
  directives: {
    inputType: {
      beforeMount: (el, bind, vueNode) => {
        for (const _arg of bind.arg.split(":")) {
          const handler = InputType[_arg];
          el.addEventListener("input", handler);
          el.addEventListener("keypress", handler);
          el.addEventListener("keyup", handler);
        }
      },
      unmounted: function (el) {
        el.removeEventListener("input", el.__vueInputType__);
        el.removeEventListener("keypress", el.__vueInputType__);
        el.removeEventListener("keyup", el.__vueInputType__);
      }
    }
  }
};

const InputType = {
  number: (e) => {
    e = e ? e : window.event;
    var charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
      e.preventDefault();
    } else {
      return true;
    }
  },
  phone: (e) => {
    e = e ? e : window.event;
    if (isNaN(e?.target?.value)) {
      e.target.value = "";
      e.preventDefault();
    }
    var charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
      e.preventDefault();
    } else {
      if (e?.target?.value?.length < 10) {
        return true;
      } else {
        e.preventDefault();
      }
    }
  },
  rupeesAmount: (e) => {
    e = e ? e : window.event;
    var charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
      e.preventDefault();
    } else {
      e.target.value = getRupees(e.target.value.replace(/[^\d]/g, ""));
    }
  },
  alphabets: (e) => {
    const code = e.keyCode || e.charCode || e.which;
    let notValid = false;
    if ((code >= 97 && code <= 122) || (code >= 65 && code <= 90) || code == 32) {
      notValid = true;
    }
    if (!notValid) {
      e.preventDefault();
      return notValid;
    }
  },
  alphanumeric: (e) => {
    const code = e.keyCode || e.charCode || e.which;
    let notValid = false;
    if ((code >= 97 && code <= 122) || (code >= 65 && code <= 90) || (code >= 48 && code <= 57) || code == 32) {
      notValid = true;
    }
    if (!notValid) {
      e.preventDefault();
      return notValid;
    }
  },
  toLower: (e) => {
    e.target.value = e?.target?.value?.toLowerCase();
  },
  toUpper: (e) => {
    e.target.value = e?.target?.value?.toUpperCase();
  }
};

function getRupees(text) {
  let value = text ? text.toString().replace(/,/g, "") : "";
  let val = Math.round(value).toString();
  let lastThree = val.substring(val.length - 3);
  let otherNumbers = val.substring(0, val.length - 3);
  if (otherNumbers != "") lastThree = "," + lastThree;
  const formatText = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
  return formatText.replace(/^0+/, "");
}
